function openItems() {
    const items = document.querySelectorAll('.answers__item');

    items.forEach((item) => {
        const answer = item.querySelector('.answer_container');
        const arrow = item.querySelector('.arrow_to_up');

        item.addEventListener('click', () => {
            answer.classList.toggle('show');
            item.classList.toggle('answers__item--opened');
            arrow.classList.toggle('arrow_to_up--opened');

        })
    })
}

export default openItems;